import React, { useState } from "react";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";
import { Calendar } from "./ui/calendar";
import { CalendarDays } from "lucide-react";
import { useTranslation } from "react-i18next";

function parseISO(s) {
  if (!s) return undefined;
  const [y, m, d] = s.split("-").map(Number);
  if (!y || !m || !d) return undefined;
  return new Date(y, m - 1, d);
}

function toISO(d) {
  if (!d) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

const DATE_LOCALES = { ro: "ro-RO", en: "en-GB", fr: "fr-FR", de: "de-DE", it: "it-IT", es: "es-ES", pt: "pt-PT", "pt-BR": "pt-BR", sr: "sr-Latn-RS" };

function formatDisplay(s, lang) {
  const d = parseISO(s);
  if (!d) return "";
  const loc = DATE_LOCALES[lang] || DATE_LOCALES[String(lang || "").split("-")[0]] || "ro-RO";
  try { return d.toLocaleDateString(loc, { day: "2-digit", month: "short", year: "numeric" }); } catch { return s; }
}

/**
 * LodgeDatePicker — shadcn Calendar wrapped in a Popover with the same
 * visual treatment as `.input-lodge` native inputs. Outputs ISO `YYYY-MM-DD`.
 */
export default function LodgeDatePicker({ value, onChange, required, placeholder, testId, disabled = false }) {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const selected = parseISO(value);
  const ph = placeholder || t("common.selectDate");

  return (
    <Popover open={disabled ? false : open} onOpenChange={disabled ? () => {} : setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          className="input-lodge flex items-center justify-between"
          style={{
            textAlign: "left",
            cursor: disabled ? "not-allowed" : "pointer",
            minHeight: "38px",
            opacity: disabled ? 0.55 : 1,
          }}
          data-testid={testId}
        >
          <span style={{ color: value ? "#1a1a19" : "#858481", fontStyle: value ? "normal" : "italic" }}>
            {value ? formatDisplay(value, i18n.language) : ph}
          </span>
          <CalendarDays size={14} color="#9a7530" />
          {required && !value && <input type="text" required value="" onChange={() => {}} style={{ position: "absolute", opacity: 0, width: 0, height: 0 }} />}
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0" align="start" style={{ background: "#fff", border: "1px solid #c9a84c" }}>
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => {
            onChange(toISO(d));
            setOpen(false);
          }}
          captionLayout="dropdown-buttons"
          fromYear={1940}
          toYear={2035}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
